import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import FeatherIcon from 'feather-icons-react';
import classNames from 'classnames';

// components
import Scrollbar from '../../components/Scrollbar';

// images
import logo from '../../assets/images/logoSm.png';
import { GoDashboard } from "react-icons/go";
import { RiShieldUserLine } from "react-icons/ri";
import { BsWindowStack } from "react-icons/bs";

import ProfileDropdown from '../../components/ProfileDropdown';
// images
import profilePic from '../../assets/images/users/avatar-1.jpg';
import { Divider, FloatButton, Space } from 'antd';
import { CommentOutlined, CustomerServiceOutlined, UserOutlined } from '@ant-design/icons';
import MaximizeScreen from '../../components/MaximizeScreen';
import NotificationDropdown from '../../components/NotificationDropdown';

import { MdKeyboardDoubleArrowLeft } from "react-icons/md";
import { useSelector } from 'react-redux';
import { RootState } from '../../redux/store';
import SharingDashPage from '../../components/SharingDashPage';
import SharingDashPageInfo from '../../components/SharingDashPageInfo';
import SlideShowScreen from '../../components/SlideShowScreen';
import SetResponsive from '../../components/SetResponsive';
import ResponSiveDropDown from '../../components/ResponSiveDropDown';

export interface NotificationItem {
    id: number;
    text: string;
    subText: string;
    icon?: string;
    avatar?: string;
    bgColor?: string;
}
/**
 * Renders the application menu
 */
interface Item {
    key: string;
    label: string;
    isTitle?: boolean;
    icon?: string;
    url?: string;
    badge?: {
        variant: string;
        text: string;
    };
    parentKey?: string;
    target?: string;
    children?: Item[];
}

interface AppMenuProps {
    menuItems: Item[];
    toggleMenu: (item: Item, show: boolean) => void;
    activeMenuItems: string[];
}

const IconMenu = ({ menuItems, toggleMenu, activeMenuItems }: AppMenuProps) => {
    const location = useLocation();
    const { isSlideShow, isDrag } = useSelector((state: any) => state.DashboardPage);


    const { userDetails } = useSelector((state: RootState) => ({
        userDetails: state.Auth.userDetails,
        loading: state.Auth.loading,
        error: state.Auth.error,
    }));


    const onMenuItemClick = (e: any, menuItem: Item) => {
        const hasChildren = menuItem.children! && menuItem.children.length;
        if (hasChildren) {
            e.preventDefault();
        }
        toggleMenu(menuItem, true);
    };

    const retIconMenu = (item: any) => {
        switch (item.key) {
            case "92047d21-6871-ed11-ac26-14d64d18fb57":
                {
                    return <GoDashboard style={{ fill: 'white' }} />
                }
            case "87eac1dc-1e9a-ed11-ac31-000aeb4bfdc5":
                return <RiShieldUserLine style={{ fill: 'white' }} />

            case "20368732-da0b-f011-b6e1-a44cc879da58":
                {
                    return <BsWindowStack style={{ fill: 'white', transform: "scaleX(-1)" }} />
                }

            default:
                return <FeatherIcon icon={item.icon} />
        }
    }

    const ProfileMenus = [
        {
            label: 'حساب کاربری',
            icon: 'user',
            redirectTo: '/account/profile',
        },
        // {
        //     label: 'قفل کردن داشبورد',
        //     icon: 'lock',
        //     redirectTo: '/auth/lock-screen',
        // },

        {
            label: 'خروج',
            icon: 'log-out',
            redirectTo: '/auth/logout',
            //redirectTo: '/auth/login',        
        },
    ];



    const Notifications: NotificationItem[] = [
        // {
        //     id: 1,
        //     text: 'پیامی وجود ندارد',
        //     subText: '',
        //     avatar: profilePic,
        // },
        // {
        //     id: 2,
        //     text: 'Caleb Flakelar commented on Admin',
        //     subText: '1 min ago',
        //     icon: 'uil uil-comment-message',
        //     bgColor: 'primary',
        // },    
        // {
        //     id: 4,
        //     text: 'New user registered.',
        //     subText: '5 hours ago',
        //     icon: 'uil uil-user-plus',
        //     bgColor: 'warning',
        // },
        // {
        //     id: 5,
        //     text: 'Caleb Flakelar commented on Admin',
        //     subText: '1 min ago',
        //     icon: 'uil uil-comment-message',
        //     bgColor: 'info',
        // },
        // {
        //     id: 6,
        //     text: 'Carlos Crouch liked Admin',
        //     subText: '13 days ago',
        //     icon: 'uil uil-heart',
        //     bgColor: 'secondary',
        // },
    ];

    return (
        <>
            <div className="sidebar-icon-menu h-100">
                <Scrollbar style={{ maxHeight: '100%' }} timeout={500} scrollbarMaxSize={320}>
                    {userDetails?.userId && !isSlideShow ?
                        <>
                            {userDetails?.defaultPage && userDetails?.defaultPage != "" ?
                                <Link to={userDetails?.defaultPage != "" ? `/dashboard/dashboardPage/${userDetails?.defaultPage}` : "/"} className="logo">
                                    <span>
                                        <img src={logo} alt="" width={45} height={45} />
                                    </span>
                                </Link>
                                :
                                <span className="logo">
                                    <img src={logo} alt="" width={45} height={45} />
                                </span>
                            }

                            <nav className="nav flex-column" id="two-col-sidenav-main">
                                {(menuItems || [])?.map((item, index) => {
                                    const activeParent =
                                        activeMenuItems &&
                                        activeMenuItems.length &&
                                        activeMenuItems[activeMenuItems.length - 1] === item['key'];
                                    return (
                                        <Link
                                            style={{ fontFamily: 'IRANSans' }}
                                            key={index}
                                            className={classNames('nav-link', 'nav-link-ref', {
                                                active: activeParent,
                                            })}
                                            to={item.children! ? '/#' : item.url!}
                                            title={item.label}
                                            data-menu-key={item.key}
                                            onClick={(e: any) => {
                                                onMenuItemClick(e, item);
                                            }}>

                                            {retIconMenu(item)}
                                        </Link>
                                    );
                                })}
                            </nav>
                        </>
                        :
                        <span className="logo">
                            <img src={logo} alt="" width={45} height={45} />
                        </span>
                    }

                </Scrollbar>
                <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', flexDirection: 'column' }}>
                    <div style={{ height: 1, backgroundColor: '#f0f0f054', width: '90%', marginBottom: 5 }}></div>
                    <Space direction="vertical" size={4} style={{ display: 'flex' }}>
                        {isSlideShow && <>
                            <SlideShowScreen menuItems={menuItems} />
                        </>}
                        {(userDetails?.userId === undefined) && <>
                            <MaximizeScreen />
                            <SharingDashPageInfo />
                        </>}
                        {userDetails?.userId && !isSlideShow &&
                            <>
                                <NotificationDropdown notifications={Notifications} />
                                {location.pathname.indexOf('/dashboard/dashboardPage') !== -1 &&
                                    <>
                                        <SharingDashPage />
                                        <ResponSiveDropDown />
                                        <SlideShowScreen menuItems={menuItems} />
                                    </>
                                }

                                <MaximizeScreen />
                                <ProfileDropdown profilePic={profilePic} menuItems={ProfileMenus} username={userDetails?.fullName} />
                            </>
                        }
                    </Space>
                </div>
            </div>
        </>
    );
};

export default IconMenu;
